import React, { memo } from 'react'

import type { FocusState, OfferCategory, SelectedCategory } from '../../../../types'
import { Options } from '../../../Options'
import * as S from './styled'

type CategoryOptionsProps = {
  isVisible: boolean
  options: OfferCategory[]
  initialCategory: SelectedCategory
  selectedCategory: SelectedCategory
  searchValue: string
  isLoading: boolean
  focusState: FocusState
  onSelect: (category: SelectedCategory) => void
  onNavigateUp: () => void
  onNavigateDown: (category: SelectedCategory) => void
}

export const CategoryOptions = memo(
  ({
    isVisible,
    options,
    initialCategory,
    selectedCategory,
    searchValue,
    isLoading,
    focusState,
    onSelect,
    onNavigateUp,
    onNavigateDown,
  }: CategoryOptionsProps) => {
    if (!isVisible) return null

    return (
      <S.OptionsContainer>
        <Options
          options={options}
          initialCategory={initialCategory}
          selectedCategory={selectedCategory}
          searchValue={searchValue}
          loading={isLoading}
          focusState={focusState}
          onSelect={onSelect}
          onNavigateUp={onNavigateUp}
          onNavigateDown={onNavigateDown}
        />
      </S.OptionsContainer>
    )
  },
)
